import { Box, styled } from '@mui/material';
import { spaceCadet } from '../utils/colors';

const StyledBox = styled(Box)(() => ({

  '& form[data-amplify-authenticator-signin] > div': {
    '& > fieldset,& > button': {
      display: 'none',
    },
  },
  '& [data-amplify-container]': {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'stretch',

    '& .amplify-tabs': {
      '& .amplify-tabs-item': {
        '&[aria-selected="false"]': {
          backgroundColor: spaceCadet[100],
        },
      },
    },
    '& [data-amplify-router]': {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',

      '& > div': {
        width: '100%',
        maxWidth: 768,
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
        borderRadius: 4,
      },
    },
  },
  '& form[data-amplify-authenticator-signin] fieldset > div:last-of-type': {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
    alignItems: 'center',
    '& label.amplify-label': {
      lineHeight: '18px',
    },
    '& .amplify-field-group.amplify-field-group--horizontal': {
      height: 18,
      '& .amplify-field-group__field-wrapper': {
        height: 18,
      },
    },
  },
}));
export default StyledBox;
